import { render, staticRenderFns } from "./Qingdanzimu.vue?vue&type=template&id=fafbf2ee&scoped=true"
import script from "./Qingdanzimu.vue?vue&type=script&lang=js"
export * from "./Qingdanzimu.vue?vue&type=script&lang=js"
import style0 from "./Qingdanzimu.vue?vue&type=style&index=0&id=fafbf2ee&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fafbf2ee",
  null
  
)

export default component.exports